import { AngularFireModule, FIREBASE_OPTIONS } from "@angular/fire/compat";

import { NgModule } from "@angular/core";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "@app/../environments/environment";
import { AppRoutingModule } from "@app/app-routing.module";
import { AppComponent } from "@app/core/components/app/app.component";
import { CoreModule } from "@app/core/core.module";
import { RootStoreModule } from "@app/root-store/root-store.module";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { NgxPermissionsModule } from "ngx-permissions";
import { FirebaseAuthService } from "./auth/services/firebase-auth.service";
import { GoogleMapsModule } from "@angular/google-maps";

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        RootStoreModule,
        BrowserAnimationsModule,
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        NgxPermissionsModule.forRoot(),
        CoreModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule,
        GoogleMapsModule,
    ],
    bootstrap: [AppComponent],
    providers: [FirebaseAuthService, { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig }],
})
export class AppModule {}
